export default __webpack_public_path__ + "static/media/IMG_102.e0113de9.jpg";